
    var riot = require('riot')
    //src: starling/src/tags/waypoints-tab-item-menu.html
riot.tag2('waypoints-tab-item-menu',
  '<ul class="floating-menu_list"> <li class="floating-menu_item" onclick="{startEditingTitle}"> <i class="material-icons floating-menu_icon">text_fields</i> <span class="floating-menu_label">Rename waypoint</span> </li> <li class="floating-menu_item" onclick="{editWaypoint}"> <i class="material-icons floating-menu_icon">format_shapes</i> <span class="floating-menu_label">Edit waypoint</span> </li> <li class="floating-menu_divider"></li> <li class="floating-menu_item" onclick="{removeWaypoint}"> <i class="material-icons floating-menu_icon">delete</i> <span class="floating-menu_label">Delete waypoint</span> </li> </ul>',
  '',
  'class="floating-menu floating-menu--hidden floating-menu--fixed"', function(opts) {
"use strict";

var _opts = opts,
    canvas = _opts.canvas;

canvas.waypointsTabItemMenu = this;

this.startEditingTitle = function (event) {
  return canvas.waypointsTabTag.startEditingTitle(event);
};

this.editWaypoint = function () {
  return canvas.waypointsTabTag.editWaypoint();
};

this.removeWaypoint = function () {
  return canvas.waypointsTabTag.removeWaypoint();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('waypoints-tab-item-menu')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/waypoints-tab-item-menu.html
// module id = 667
// module chunks = 0